import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const MERCADO_PAGO_URL = '#comprar';
export function StickyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-221">
      {visible && <motion.div initial={{
      y: -80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -80,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed inset-x-0 top-0 z-50 bg-orange shadow-lg" data-id="element-222">
          <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-3 py-2 sm:px-6" data-id="element-223">
            <div className="flex items-center gap-2 sm:gap-3" data-id="element-224">
              <span className="hidden font-heading text-xs font-bold uppercase tracking-wide text-white sm:inline" data-id="element-225">
                Oferta cierra en
              </span>
              <CountdownTimer size="sm" data-id="element-226" />
            </div>
            <a href={MERCADO_PAGO_URL} className="inline-flex items-center gap-2 whitespace-nowrap rounded-lg bg-white px-4 py-2 font-heading text-xs font-bold uppercase tracking-wide text-carbon transition-transform hover:scale-[1.03] sm:px-6 sm:text-sm" data-id="element-227">
              Quiero mi megapack
              <ArrowRightIcon className="h-4 w-4" data-id="element-228" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}